import React, { useState, useEffect } from 'react'
import i18n from '@pureartisan/simple-i18n'
import clsx from 'clsx'
import shallow from 'zustand/shallow'
import copy from 'copy-to-clipboard'
import { FiCopy, FiCode, FiLink } from 'react-icons/fi'
import { IconButton, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import useStore from './../store'
import { DEFAULT_ROUTE } from '../../../../constants/map'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: 'Fira Sans',
    margin: '0.5rem 0',
  },
  labelGroup: {
    flex: '1 0 100%',
    marginBottom: '6px',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& svg': {
      marginRight: '10px',
      stroke: theme.extras.variables.colors.ddkAnotherGray,
      strokeWidth: '3px',
    },
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: theme.extras.variables.colors.ddkAnotherGray,
  },
  label: {},
  input: {
    height: '33px',
    flex: '1 0 76%',
    border: 0,
    backgroundColor:
      theme.extras.variables.colors
        .ddkYetAnotherAnotherLightGray,
    fontFamily: 'Fira Sans',
    color: theme.extras.variables.colors.ddkAnotherGray,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    padding: '0 0.5rem',
  },
  button: {
    flex: '0 0 15%',
    height: '33px',
    width: '20px',
    padding: '0 4px 0 4px',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    borderRadius: 0,
    fontSize: '2.2rem',
    '&:hover': {
      color:
        theme.extras.variables.colors.ddkAnotherOneOffBlue,
      stroke:
        theme.extras.variables.colors.ddkAnotherOneOffBlue,
      backgroundColor:
        theme.extras.variables.colors.ddkALighterOneOffBlue,
    },
    '& svg': {
      stroke: theme.extras.variables.colors.ddkAnotherNavy,
      '&:hover': {
        stroke:
          theme.extras.variables.colors
            .ddkAnotherOneOffBlue,
      },
    },
  },
}))

/**
 * Render an input with a copy button,
 * for copying and pasting share or embed links
 * type = string, link or embed
 */
const ShareCopyInput = ({ type, ...props }) => {
  const { shareHash, incrementEvent } = useStore(
    state => ({
      shareHash: state.shareHash,
      incrementEvent: state.incrementEvent,
    }),
    shallow,
  )
  // Update value for share link only when window object exists.
  const [shareValue, setShareValue] = useState('')
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    let updateValue = !!shareHash
      ? window.location.origin +
        window.location.pathname +
        shareHash
      : window.location.origin +
        window.location.pathname +
        DEFAULT_ROUTE

    if (type === 'embed') {
      const embedLink = updateValue.replace(
        'explorer',
        'embed',
      )
      updateValue = `<iframe src="${embedLink}" style="width:720px;height:405px;max-width:100%;" frameborder="0"></iframe>`
    }

    setShareValue(updateValue)
  }, [shareHash])

  const onCopy = () => {
    copy(shareValue)
    incrementEvent(
      type === 'embed'
        ? 'eventShareEmbed'
        : 'eventShareLink',
    )
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 1000)
  }
  const classes = useStyles()
  return (
    <div className={clsx(classes.root)}>
      <div
        className={clsx(classes.labelGroup)}
        id={`share_label_${type}`}
      >
        {type === 'embed' && <FiCode />}
        {type !== 'embed' && <FiLink />}
        <span className={clsx(classes.label)}></span>
        {type === 'embed'
          ? i18n.translate(`BUTTON_SHARE_EMBED`)
          : i18n.translate(`MODAL_SHARE_LINK_INPUT`)}
      </div>
      <input
        aria-labelledby={`share_label_${type}`}
        value={shareValue}
        className={clsx(classes.input)}
        readOnly={true}
      ></input>
      <Tooltip
        arrow
        open={copied}
        title={i18n.translate(`MODAL_SHARE_COPIED`)}
        placement="top"
      >
        <IconButton
          onClick={onCopy}
          label={i18n.translate(`BUTTON_SHARE_EMBED`)}
          className={clsx(classes.button)}
        >
          <FiCopy className={clsx(classes.icon)} />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export default ShareCopyInput
